import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ProductosService } from '../../services/productos.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss']
})
export class ProductoComponent implements OnInit {

  @ViewChild('sectionSubscribe', { static: true }) sectionSubscribeDiv: ElementRef;

  public user = this.authSvc.afAuth.user;
  perfilUser: any;
  showModal = false;
  carrito = [];
  solicitud: any = {
    idprod: '',
    nombreprod: '',
    imagenProd: '',
    precio: 0,
    cantidad: 0,
    descuento: 0,
    subtotal: 0,
    total: 0,
    estado: 'Pendiente',
    fecha: new Date().getTime(),
  };

  cant = 1;
  detalle: any;
  nombre: string;
  imagen: string;
  precio: number;
  descuento: number;
  cantidad: number;
  categoria: string;
  descripcion: string;
  beneficios: any;
  uso: string;
  idProd: string;
  presentacion: string;
  elementPosition: any;

  verificationListShopCar = [];

  productoCar = false;
  agregar = true;


  constructor(private productoSvc: ProductosService,
              private route: ActivatedRoute,
              private authSvc: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.scrollToSubscribe();
    this.loadStorage();
    this.user.subscribe(resp => {
      this.perfilUser = resp;
      if (!this.perfilUser) {
       this.showModal = true;
      }
 });
    const id = this.route.snapshot.paramMap.get('id');
    this.idProd = id;
    this.productoSvc.loadProductById(id)
                    .subscribe(res => {
                      this.detalle = res;
                      this.cantidad = this.detalle.cantidad;
                      this.nombre = this.detalle.nombre;
                      this.precio = this.detalle.precio;
                      this.imagen = this.detalle.imagen;
                      this.descuento = this.detalle.descuento;
                      this.categoria = this.detalle.categoria;
                      this.beneficios = this.detalle.beneficios;
                      this.descripcion = this.detalle.descripcion;
                      this.uso = this.detalle.uso;
                      this.presentacion = this.detalle.presentacion;
                      this.verificaproductoAgregado();
                    });
  }

  loadStorage(){
    if (localStorage.getItem('dataCarShopTorreonMarket')) {
      this.carrito = JSON.parse( localStorage.getItem('dataCarShopTorreonMarket'));
    }
  }

  scrollToSubscribe(){
    this.sectionSubscribeDiv.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  cantidadProducto(operacion: string){
    if (operacion === 'restar') {
      this.cant--;
      if (this.cant < 1) {
        this.cant = 1;
      }
      this.verificaproductoAgregado();
    }
    if (operacion === 'sumar') {
      this.cant++;
      if (this.cant > this.cantidad) {
        this.cant = this.cantidad;
      }
      this.verificaproductoAgregado();
    }
  }

  verificaproductoAgregado(){
    let newCantProd = 0;
    for (const key in this.carrito){
      if (this.carrito[key].idprod === this.idProd) {
        newCantProd = this.carrito[key].cantidad + this.cant;
        if (newCantProd <= this.cantidad) {
          this.carrito[key].cantidad = newCantProd;
          this.carrito[key].subtotal = newCantProd * this.carrito[key].precio;
          this.carrito[key].total = this.carrito[key].subtotal - ((this.carrito[key].subtotal * this.carrito[key].descuento)/100);
          this.productoCar = true;
        } else {
          this.agregar = false;
        }
      }
      this.verificationListShopCar.push(this.carrito[key]);
    }

  }

  sendRequest(){
    if (this.cantidad > 0) {
      if (!this.agregar) {
        Swal.fire('Por favor verifique su carrito de compras, es posible que ya cuente con este producto agregado');
        return;
        // this.router.navigate(['/solicitudes']);
      } else {
        if (this.productoCar) {
          this.carrito = this.verificationListShopCar;
          localStorage.setItem('dataCarShopTorreonMarket', JSON.stringify(this.carrito));
          this.router.navigate(['/solicitudes']);
        }
        if (!this.productoCar) {
          const total = Number(this.cant) * Number(this.precio);
          const totalDesc = (total * this.descuento) / 100;
          const totalNeto = total - totalDesc;
          this.solicitud.idprod = this.idProd;
          this.solicitud.nombreprod = this.nombre;
          this.solicitud.imagenProd = this.imagen;
          this.solicitud.precio = this.precio;
          this.solicitud.cantidad = this.cant;
          this.solicitud.descuento =  this.descuento;
          this.solicitud.subtotal = total;
          this.solicitud.total = totalNeto;
          this.carrito.push(this.solicitud);
          localStorage.setItem('dataCarShopTorreonMarket', JSON.stringify(this.carrito));
          this.router.navigate(['/solicitudes']);
        }
      }
    } else {
      Swal.fire(
        'Producto agotado :(',
        'Por el momento no tenemos inventario para la venta',
        'error'
      );
    }




    if (!this.agregar) {
       this.router.navigate(['/solicitudes']);
       return;
    }
    this.verificaproductoAgregado();
        if (this.productoCar) {

          return;
        }

  }

  onLoginFacebook(){
    this.authSvc.loginFacebook().then(resp => {
      const id = resp.user.uid;
      const datos = {
                  id: resp.user.uid,
                  email: resp.user.email
                };
      this.authSvc.verifyUser(id)
                  .subscribe(usr => {
                    if (usr.length === 0) {
                      this.authSvc.createUserData(id, datos)
                                  .then(usuario => {
                                    this.showModal = false;
                                    Swal.fire({
                                      title: 'Usuario registrado',
                                      text: 'Se ha creado registro con facebook',
                                      icon: 'success',
                                      showCancelButton: false,
                                      confirmButtonColor: '#3085d6',
                                      cancelButtonColor: '#d33',
                                      confirmButtonText: 'Continuar'
                                    }).then((result) => {
                                      location.reload();
                                    });
                                  });
                    } else if (usr.length > 0) {
                      this.showModal = false;
                      Swal.fire({
                        title: 'Hola de nuevo',
                        text: 'Gracias por visitar Torreón Market',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Continuar'
                      }).then((result) => {
                        location.reload();
                      });
                    }
                  });
    }).catch(err => console.log('Error', err.message));
  }

  onLoginGoogle(){
    this.authSvc.loginGoogle().then(resp => {
      const id = resp.user.uid;
      const datos = {
                  id: resp.user.uid,
                  email: resp.user.email
                };
      this.authSvc.verifyUser(id)
                  .subscribe(usr => {
                    if (usr.length === 0) {
                      this.authSvc.createUserData(id, datos)
                                  .then (save => {
                                    this.showModal = false;
                                    Swal.fire({
                                      title: 'Usuario registrado',
                                      text: 'Se ha creado registro con Google',
                                      icon: 'success',
                                      showCancelButton: false,
                                      confirmButtonColor: '#3085d6',
                                      cancelButtonColor: '#d33',
                                      confirmButtonText: 'Continuar'
                                    }).then((result) => {
                                      location.reload();
                                    });
                                  });
                    } else if (usr.length > 0) {
                      this.showModal = false;
                      Swal.fire({
                        title: 'Hola de nuevo',
                        text: 'Gracias por visitar Torreón Market',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Continuar'
                      }).then((result) => {
                        location.reload();
                      });
                    }
                  });
    }).catch(err => console.log('Error', err.message));
  }

  onLoginRedirect(){
    this.router.navigate(['/home']);
  }

}
